import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SOConsolidationTemplateModel } from "../../../../../../models/aggregates/so-consolidation/index";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class SOConsolidationTemplateService extends BaseApiTemplateService<SOConsolidationTemplateModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/template-hdrs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/template-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}
